export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

const LAST_ACTIVITY_KEY = "lastActivity";

export function isLoggedIn(): boolean {
  try {
    return localStorage.getItem("isLoggedIn") === "true";
  } catch {
    return false;
  }
}

export function touchActivity(): void {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  } catch {
    // ignore storage errors
  }
}

export function getLastActivity(): number {
  try {
    const value = localStorage.getItem(LAST_ACTIVITY_KEY);
    return value ? parseInt(value, 10) : Date.now();
  } catch {
    return Date.now();
  }
}

export function isSessionExpired(): boolean {
  return Date.now() - getLastActivity() > SESSION_TIMEOUT_MS;
}

export function clearSession(): void {
  try {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    // ignore storage errors
  }
}
